<span matSnackBarLabel>
  {{ data.text }}
</span>
<span matSnackBarActions>
  <mat-icon>{{ data.icon }}</mat-icon>
</span>
